import React from 'react';
import { ApiHandler, IntegrationDetails } from '@givelify/api';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';

export const INTEGRATION_QUERY_KEY =
    ApiHandler.instance.donees.getIntegrationDetails.name;

export const useIntegration = (
    donorId: number,
    initialData?: IntegrationDetails,
    enabled = true,
) => {
    const query = useQuery({
        queryKey: [INTEGRATION_QUERY_KEY, donorId],
        queryFn: async () => {
            const response =
                await ApiHandler.instance.donees.getIntegrationDetails(donorId);

            if (response.success) {
                if (response.response.data.settings?.exportStartDate) {
                    response.response.data.settings.exportStartDate = dayjs(
                        response.response.data.settings.exportStartDate,
                    );
                } else if (
                    response.response.data.settings?.exportStartDate !==
                    undefined
                ) {
                    response.response.data.settings.exportStartDate = null;
                }
            }
            return response;
        },
        initialData: initialData
            ? {
                  response: {
                      data: initialData,
                  },
                  success: true,
              }
            : undefined,
        enabled: enabled && !!donorId,
    });

    const integration = React.useMemo(() => {
        if (query.data && query.data.success) {
            return query.data.response.data;
        }
        return null;
    }, [query.data]);

    const errorMessage = React.useMemo(() => {
        if (query.data && !query.data.success) {
            return query.data.error.message;
        }
        return '';
    }, [query.data]);

    return { ...query, integration, errorMessage };
};
